export default __webpack_public_path__ + "static/media/LP-D2-CW.99631314.jpg";